import { gql } from '@apollo/client'

export const GET_EMAIL_CONTENT = gql`
  query GetDecisionEmail($input: DecisionEmailRequestInput!) {
    decisionEmail(request: $input) {
      emailBody
      isDealUpdated
      emailTemplateId
      dealId
      didError
      errorMessage
      __typename
    }
  }
`
